import type { IconSvgProps } from '../iconProps';

const ExcelIcon = ({ theme: _theme, ...props }: IconSvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.75 22H21.25C21.3875 22 21.5 21.8875 21.5 21.75V7H17.25C16.8365 7 16.5 6.6635 16.5 6.25V2H6.75C6.6125 2 6.5 2.1125 6.5 2.25V21.75C6.5 21.8875 6.6125 22 6.75 22Z"
      fill="white"
    />
    <path
      d="M21.1465 6.50002L17 2.35352V6.25002C17 6.38752 17.1125 6.50002 17.25 6.50002H21.1465Z"
      fill="white"
    />
    <path
      opacity="0.64"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.78 6.427L17.073 1.7195C16.9321 1.57945 16.7417 1.50059 16.543 1.5H6.75C6.3365 1.5 6 1.8365 6 2.25V21.75C6 22.1635 6.3365 22.5 6.75 22.5H21.25C21.6635 22.5 22 22.1635 22 21.75V6.957C22 6.757 21.922 6.5685 21.78 6.427ZM17 2.3535L21.1465 6.5H17.25C17.1837 6.49987 17.1202 6.47349 17.0734 6.42663C17.0265 6.37978 17.0001 6.31626 17 6.25V2.3535ZM6.75 22H21.25C21.3875 22 21.5 21.8875 21.5 21.75V7H17.25C16.8365 7 16.5 6.6635 16.5 6.25V2H6.75C6.6125 2 6.5 2.1125 6.5 2.25V21.75C6.5 21.8163 6.52634 21.8799 6.57322 21.9268C6.62011 21.9737 6.6837 22 6.75 22Z"
      fill="#605E5C"
    />
    <path
      d="M19.5 15.5H18C17.8674 15.5 17.7402 15.4473 17.6464 15.3536C17.5527 15.2598 17.5 15.1326 17.5 15C17.5 14.8674 17.5527 14.7402 17.6464 14.6464C17.7402 14.5527 17.8674 14.5 18 14.5H19.5C19.6326 14.5 19.7598 14.5527 19.8536 14.6464C19.9473 14.7402 20 14.8674 20 15C20 15.1326 19.9473 15.2598 19.8536 15.3536C19.7598 15.4473 19.6326 15.5 19.5 15.5Z"
      fill="#134A2C"
    />
    <path
      d="M16 15.5H14.5C14.3674 15.5 14.2402 15.4473 14.1464 15.3536C14.0527 15.2598 14 15.1326 14 15C14 14.8674 14.0527 14.7402 14.1464 14.6464C14.2402 14.5527 14.3674 14.5 14.5 14.5H16C16.1326 14.5 16.2598 14.5527 16.3536 14.6464C16.4473 14.7402 16.5 14.8674 16.5 15C16.5 15.1326 16.4473 15.2598 16.3536 15.3536C16.2598 15.4473 16.1326 15.5 16 15.5Z"
      fill="#185C37"
    />
    <path
      d="M19.5 13.5H18C17.8674 13.5 17.7402 13.4473 17.6464 13.3536C17.5527 13.2598 17.5 13.1326 17.5 13C17.5 12.8674 17.5527 12.7402 17.6464 12.6464C17.7402 12.5527 17.8674 12.5 18 12.5H19.5C19.6326 12.5 19.7598 12.5527 19.8536 12.6464C19.9473 12.7402 20 12.8674 20 13C20 13.1326 19.9473 13.2598 19.8536 13.3536C19.7598 13.4473 19.6326 13.5 19.5 13.5Z"
      fill="#21A366"
    />
    <path
      d="M16 13.5H14.5C14.3674 13.5 14.2402 13.4473 14.1464 13.3536C14.0527 13.2598 14 13.1326 14 13C14 12.8674 14.0527 12.7402 14.1464 12.6464C14.2402 12.5527 14.3674 12.5 14.5 12.5H16C16.1326 12.5 16.2598 12.5527 16.3536 12.6464C16.4473 12.7402 16.5 12.8674 16.5 13C16.5 13.1326 16.4473 13.2598 16.3536 13.3536C16.2598 13.4473 16.1326 13.5 16 13.5Z"
      fill="#107C41"
    />
    <path
      d="M19.5 11.5H18C17.8674 11.5 17.7402 11.4473 17.6464 11.3536C17.5527 11.2598 17.5 11.1326 17.5 11C17.5 10.8674 17.5527 10.7402 17.6464 10.6464C17.7402 10.5527 17.8674 10.5 18 10.5H19.5C19.6326 10.5 19.7598 10.5527 19.8536 10.6464C19.9473 10.7402 20 10.8674 20 11C20 11.1326 19.9473 11.2598 19.8536 11.3536C19.7598 11.4473 19.6326 11.5 19.5 11.5Z"
      fill="#33C481"
    />
    <path
      d="M16 11.5H14.5C14.3674 11.5 14.2402 11.4473 14.1464 11.3536C14.0527 11.2598 14 11.1326 14 11C14 10.8674 14.0527 10.7402 14.1464 10.6464C14.2402 10.5527 14.3674 10.5 14.5 10.5H16C16.1326 10.5 16.2598 10.5527 16.3536 10.6464C16.4473 10.7402 16.5 10.8674 16.5 11C16.5 11.1326 16.4473 11.2598 16.3536 11.3536C16.2598 11.4473 16.1326 11.5 16 11.5Z"
      fill="#21A366"
    />
    <path
      d="M3 18.5H12C12.2652 18.5 12.5196 18.3946 12.7071 18.2071C12.8946 18.0196 13 17.7652 13 17.5V8.5C13 8.23478 12.8946 7.98043 12.7071 7.79289C12.5196 7.60536 12.2652 7.5 12 7.5H3C2.73478 7.5 2.48043 7.60536 2.29289 7.79289C2.10536 7.98043 2 8.23478 2 8.5V17.5C2 17.7652 2.10536 18.0196 2.29289 18.2071C2.48043 18.3946 2.73478 18.5 3 18.5Z"
      fill="#107C41"
    />
    <path
      d="M4.75929 16L6.68429 12.9915L4.92129 10H6.34079L7.30379 11.9125C7.39229 12.0935 7.45279 12.229 7.48629 12.318H7.49879C7.56229 12.173 7.62879 12.032 7.69779 11.8955L8.72729 10H10.0298L8.21979 12.975L10.0748 16H8.68979L7.57729 13.9C7.52494 13.8106 7.4806 13.7167 7.44479 13.6195H7.42829C7.39605 13.7146 7.35293 13.8057 7.29979 13.891L6.15379 16H4.75879H4.75929Z"
      fill="#F9F7F7"
    />
  </svg>
);

export default ExcelIcon;
